import { render, staticRenderFns } from "./AlertSunExpert5Years.vue?vue&type=template&id=54e5464f"
import script from "./AlertSunExpert5Years.vue?vue&type=script&lang=js"
export * from "./AlertSunExpert5Years.vue?vue&type=script&lang=js"
import style0 from "./AlertSunExpert5Years.vue?vue&type=style&index=0&id=54e5464f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports